'use client';

import type { GrowthBookPayload } from '@growthbook/growthbook-react';

import type { AppStateRoot } from '@app/app-state';
import { GrowthbookAppProvider } from '@app/components/providers/growthbook-provider/growthbook-app.provider';
import { StoreProvider } from '@app/components/providers/store-provider';
import type { ForcedFeatures } from '@app/state/helpers/cookie-app-router.helpers';
import { I18nProvider } from '@app/ui-providers/i18n-provider/i18n-provider';
import { ThemeProviderWithCache } from '@app/ui-providers/theme-provider/theme-provider-with-cache';

export const Providers = ({
    preloadedState,
    growthbookPayload,
    forcedFeatures,
    children,
}: {
    preloadedState: AppStateRoot;
    growthbookPayload: GrowthBookPayload | null;
    forcedFeatures: ForcedFeatures;
    children: React.ReactNode;
}) => (
    <StoreProvider preloadedState={preloadedState}>
        <I18nProvider>
            <ThemeProviderWithCache>
                <GrowthbookAppProvider payload={growthbookPayload} forcedFeatures={forcedFeatures}>
                    {children}
                </GrowthbookAppProvider>
            </ThemeProviderWithCache>
        </I18nProvider>
    </StoreProvider>
);
